// extracted by mini-css-extract-plugin
export var addToCartButton = "_ov-b";
export var arrowButtonContainer = "_ov-9";
export var arrowButtonIcon = "_ov-a";
export var carouselArrowButton = "_ov-6";
export var carouselElementContainer = "_ov-1";
export var left = "_ov-7";
export var productDisplayCarouselContainer = "_ov-0";
export var productTileContainer = "_ov-2";
export var productTileImage = "_ov-4";
export var productTileImageContainer = "_ov-3";
export var productTileTitle = "_ov-5";
export var right = "_ov-8";
export var sliderOverflow = "_ov-c";